import { Box, Typography } from '@mui/material';

import colors from '../../constants/colors';

interface StatusChipProps {
  label: string;
  alert?: boolean;
}

const StatusChip = ({ alert = false, label }: StatusChipProps) => (
  <Box
    sx={{
      px: 1,
      py: 0.5,
      borderRadius: alert ? 1 : 0.5,
      backgroundColor: alert ? colors.csaaRed10 : colors.csaaNeutralBackground,
    }}
  >
    <Typography
      sx={{
        fontSize: 14,
        lineHeight: '16px',
        letterSpacing: 0.2,
        color: colors.csaaDark,
        fontFamily: 'Cabin',
        fontKerning: 'normal',
        fontWeight: 500,
      }}
    >
      {label}
    </Typography>
  </Box>
);

export default StatusChip;
